<template>
  <div
    class="nftdiv rounded flex justify-between items-center flex-col bg-white bg-opacity-0 hover:border-blue-400 cursor-pointer"
  >
    <!-- <div v-if="!isOwner" class="absolute left-0 top-0 p-4 text-1xl">
        Onwed by
        <Address :address="owner" />
      </div>
      <div v-if="isOwner" class="absolute left-0 top-0  p-4 text-3xl">3rd</div>
        -->

    <div class="flex flex-col pt-0">
      <div class="flip-box">
        <div
          class="flip-box-inner"
          :class="{
            nftCard: !showDeadNfts && !playPage,
            deadCard: showDeadNfts && !playPage,
            nftCardSimple: playPage,
          }"
        >
          <div class="flip-box-front relative">
            <div class="mt-3 flex px-0 items-center justify-center">
              <div
                class="w-1/3 text-2xl mt-0 pr-0 text-white leading-tight"
                v-if="leaderboard"
              >
                <span v-if="isNftAlive">{{ addPositionSuffix(position) }}</span>
                <img
                  @click.stop="fatality"
                  v-else-if="!isNftAlive"
                  class="w-12 mx-auto"
                  src="@/assets/img/skull.svg"
                  alt=""
                />
              </div>
            </div>
            <div class="mt-5">
              <img
                id="dropzone"
                :src="image"
                alt="Person"
                :data-id="id"
                :class="{ shake: inBattle }"
                class="dropzone object-contain m-auto mb-0 mt-2 h-40 w-9/12"
                style=""
              />
              <span class="" :class="{ drop: inBattle }"></span>
              <span :class="{ drop: inBattle }"></span>
              <span :class="{ drop: inBattle }"></span>
              <span :class="{ drop: inBattle }"></span>
              <span :class="{ drop: inBattle }"></span>

              <div class="flex flex-col mt-12 pt-3">
                <div class="mt-0 text-xl flex flex-col text-center">
                  <span class="text-xs text-white h-6 font-light mt-0"
                    >ID #{{ id }}
                  </span>
                  <span class="text-xl text-white h-8 font-bold -mt-2 w-9/12 mx-auto truncate ...">{{
                    name
                  }}</span>
                </div>

                <div
                  class="flex flex-col items-center w-full"
                  v-if="leaderboard && isNftAlive"
                >
                  <div class="flex text-white font-light text-sm">
                    <div class="px-1">TOD:</div>
                    <div class="px-2">
                      <!-- {{ timeOfDeath }} -->
                      <countdown :end-time="timeOfDeath * 1000">
                        <template v-slot:process="time">
                          <div class="">
                            {{ `${time.timeObj.d}d` }}

                            {{
                              ` ${time.timeObj.h}hrs ${time.timeObj.m}m ${time.timeObj.s}s`
                            }}
                          </div>
                        </template>
                        <template v-slot:finish>
                          <span>Dead!</span>
                        </template>
                      </countdown>
                    </div>
                  </div>
                  <div class="w-8/12">
                    <div class="bg-red-800 rounded-full h-1">
                      <div
                        class="bg-green-500 rounded-full h-1 flex text-sm text-dark"
                        :style="{ width: `${hp}%` }"
                      ></div>
                    </div>
                  </div>
                </div>

                <div
                  class="w-8/12 mx-auto flex flex-row justify-between text-white font-light leading-normal mt-1"
                >
                  <div class="mx-auto">
                    <span class="text-xs">Score </span>
                    <span class="text-xs">{{ score }}</span>
                  </div>
                  <div class="mx-auto" v-if="leaderboard && isNftAlive">
                    <span class="text-xs">Born </span>
                    <span class="text-xs">{{ timeBorn | moment("from") }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="flip-box-back" id="dropzone2">
            <div class="mt-3 flex px-0 items-start justify-end pr-4">
              <div
                class="w-1/3 text-2xl mt-0 pr-0 text-white text-left leading-tight"
                v-if="leaderboard"
              >
                {{ addPositionSuffix(position) }}
              </div>

              <div
                v-if="isNftAlive && leaderboard"
                class="cursor-pointer mb-0"
                @click.stop="fatality"
              >
                <img
                  class="w-12 invisible"
                  src="../assets/img/skull.svg"
                  alt=""
                />
              </div>
            </div>
            <div class="">
              <img
                id="dropzone"
                :src="image"
                alt="Person"
                :class="{ shake: inBattle }"
                class="object-contain m-auto mb-0 mt-2 h-40"
                style=""
              />
              <span class="" :class="{ drop: inBattle }"></span>
              <span :class="{ drop: inBattle }"></span>
              <span :class="{ drop: inBattle }"></span>
              <span :class="{ drop: inBattle }"></span>
              <span :class="{ drop: inBattle }"></span>

              <div class="flex flex-col mt-10 pt-3 dropAccessory">
                <p
                  class="text-white z-50 w-3/4 mx-auto text-center font-2xl leading-normal"
                >
                  Drop the accessory to attack this player
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const axios = require("axios").default;
import Address from "@/components/Address.vue";
export default {
  name: "NFT",
  components: { Address },
  props: {
    nft: Object,
    contract: String,
    position: Number,
    id: String,
    onClicked: Function,
    leaderboard: Boolean,
    showDeadNfts: Boolean,
    playPage: Boolean,
    // inBattle: Boolean,
  },
  data: function () {
    return {
      name: "",
      image: "",
      addressOrigin: "",
      idOrigin: "",
      isNftAlive: false,
      timeUntilStarving: 0,
      timeVnftBorn: 0,
      expectedReward: 0,
      fatalityReward: 0,
      score: 0,
      level: 0,
      isOwner: false,
      owner: "",
      hp: 0,
      inBattle: false,
      timeOfDeath: 0,
    };
  },
  methods: {
    fetchInfos: async function () {
      if (this.$store.state.web3 == null) {
        return;
      }
      let infos = await this.$store.state.GameContract.methods
        .getInfo(this.nft.player_id)
        .call();
      console.log(infos);
      this.expectedReward = parseInt(infos._expectedReward);
      this.timeUntilStarving = parseInt(infos._timeUntilDeath);
      this.timeBorn = parseInt(infos._timeBorn * 1000);
      this.score = parseInt(parseInt(infos._score) / 100);
      this.level = parseInt(infos._score / 100);
      this.owner = infos._owner;
      this.isNftAlive = this.timeUntilStarving > 0;
      this.isOwner =
        this.owner.toLowerCase() == this.$store.state.account.toLowerCase();
      this.image = this.nft.nft_image;
      this.name = this.nft.nft_title;

      this.timeOfDeath = parseInt(infos._timeOfDeath);

      //this.hp = vnft.data.hp_lastseen;
    },
    fatality: async function (e) {
      const tokenId = alert(`You'll get 50 ROYAL for killing this Player`);
      let fatality = await this.$store.state.GameContract.methods
        .kill(this.id)
        .send({
          from: this.$store.state.account,
        });
    },
    addPositionSuffix: function (number) {
      // creates 1st 2nd 3rd suffixes
      var j = number % 10,
        k = number % 100;
      if (j == 1 && k != 11) {
        return number + "st";
      }
      if (j == 2 && k != 12) {
        return number + "nd";
      }
      if (j == 3 && k != 13) {
        return number + "rd";
      }
      return number + "th";
    },
  },
  beforeMount: function () {
    this.fetchInfos();
  },
  mounted: function () {},
  watch: {
    isConnected: function () {
      this.fetchInfos();
    },
  },
  computed: {
    isConnected: function () {
      return this.$store.state.web3 != null;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.shake {
  /* Start the shake animation and make the animation last for 0.5 seconds */
  animation: shake 0.5s;
  /* When the animation is finished, start again */
  animation-iteration-count: infinite;
}
@keyframes shake {
  0% {
    transform: translate(1px, 1px) rotate(0deg);
  }
  10% {
    transform: translate(-1px, -2px) rotate(-1deg);
  }
  20% {
    transform: translate(-3px, 0px) rotate(1deg);
  }
  30% {
    transform: translate(3px, 2px) rotate(0deg);
  }
  40% {
    transform: translate(1px, -1px) rotate(1deg);
  }
  50% {
    transform: translate(-1px, 2px) rotate(-1deg);
  }
  60% {
    transform: translate(-3px, 1px) rotate(0deg);
  }
  70% {
    transform: translate(3px, 1px) rotate(-1deg);
  }
  80% {
    transform: translate(-1px, -1px) rotate(1deg);
  }
  90% {
    transform: translate(1px, 2px) rotate(0deg);
  }
  100% {
    transform: translate(1px, -2px) rotate(-1deg);
  }
}
/* end shake */
.drop {
  font-size: 8rem;
  width: 0.1em;
  height: 0.1em;
  border-radius: 0 100% 100% 100%;
  background-color: #dd3524;
  position: absolute;
  top: 30%;
  animation: drop 3s infinite both;
}
/* .drop:nth-child(1) {
  left: 0%;
} */
/* .drop:nth-child(2) {
  left: 14%;
  animation-delay: -0.4s;
} */
.drop:nth-child(3) {
  left: 39%;
  animation-delay: -1.5s;
}
.drop:nth-child(4) {
  left: 55%;
  animation-delay: -0.8s;
}
/* .drop:nth-child(5) {
  left: 82.5%;
  animation-delay: -1.3s;
} */
@keyframes drop {
  0% {
    transform: translateY(0) scaleX(1) rotate(45deg);
    animation-timing-function: ease-out;
  }
  60% {
    transform: translateY(120%) scaleX(0.85) rotate(45deg);
    animation-timing-function: ease-in;
  }
  80%,
  100% {
    transform: translateY(60vh) scaleX(0.85) rotate(45deg);
  }
}
/* end battle css */
/* The flip box container - set the width and height to whatever you want. We have added the border property to demonstrate that the flip itself goes out of the box on hover (remove perspective if you don't want the 3D effect */
.flip-box {
  background-color: transparent;
  width: 275px;
  height: 420px;
  perspective: 1000px;
  /* Remove this if you don't want the 3D effect */
}
/* This container is needed to position the front and back side */
.flip-box-inner {
  position: relative;
  width: 100%;
  height: 100%;
  text-align: center;
  transition: transform 0.8s;
  transform-style: preserve-3d;
}
/* Do an horizontal flip when you move the mouse over the flip box container */
/* .flip-box:hover .flip-box-inner {
            transform: rotateY(180deg);
        } */
.rotate {
  transform: rotateY(180deg);
}
/* Position the front and back side */
.flip-box-front,
.flip-box-back {
  position: absolute;
  width: 100%;
  height: 100%;
  -webkit-backface-visibility: hidden;
  /* Safari */
  backface-visibility: hidden;
}
/* Style the front side (fallback if image is missing) */
.flip-box-front {
  color: black;
}
/* Style the back side */
.flip-box-back {
  transform: rotateY(180deg);
}
.meter span {
  display: block;
  height: 100%;
}
.progress {
  -webkit-animation: progressBar 3s ease-in-out infinite;
  -webkit-animation-fill-mode: both;
  -moz-animation: progressBar 3s ease-in-out;
  -moz-animation-fill-mode: both;
}
</style>